import { render, staticRenderFns } from "./TreinamentoComponent.vue?vue&type=template&id=6c35708c&lang=pug&"
var script = {}
import style0 from "./TreinamentoComponent.vue?vue&type=style&index=0&id=6c35708c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports